export enum UserActionTypes {
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}
